module.exports = __webpack_public_path__ + "img/QRcode_login.3acec042.png";